import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import { QueryKey } from ':cloud/queries/types';
import { APIClientBase } from ':cloud/state/Api';
import {
  SubmitBuildQuestItemRequest,
  SubmitBuildQuestItemResponse,
} from ':cloud/types/service_proto';

async function submitAnswer({
  userId,
  questionId,
  answer,
}: SubmitBuildQuestItemRequest): Promise<SubmitBuildQuestItemResponse> {
  const path = `organization-management/v1/users/${userId}/quest/items`;

  const requestBody = {
    questionId,
    answer,
  };
  const { data } = await APIClientBase.post<SubmitBuildQuestItemResponse>(path, requestBody);
  return data;
}

export function useSubmitBuildQuestAnswer(): UseMutationResult<
  SubmitBuildQuestItemResponse,
  Error,
  SubmitBuildQuestItemRequest
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      userId,
      questionId,
      answer,
    }: SubmitBuildQuestItemRequest): Promise<SubmitBuildQuestItemResponse> =>
      submitAnswer({ userId, questionId, answer }),
    onSuccess: async (data, { userId }) => {
      queryClient.setQueryData([QueryKey.buildQuest, userId], data);
    },
  });
}
